import { createContext, useContext } from "react";
import { useAgentEntitiesAPIService } from "service/AgentEntitiesAPIService";
import { useEntitiesAPI } from "service/EntitiesAPIService";

export const ClientsContext = createContext();

export const ClientsContextProvider = ({ id, entity, ...props}) => {

    const serviceAgentEntities = useAgentEntitiesAPIService();
    const serviceEntities = useEntitiesAPI();

    const fetchAll = (filters=[], page_size = 10, page = 1, stortColumns = false, callBack, errorCallBack) => {
        serviceAgentEntities.fetch(filters, page_size, page, stortColumns, callBack, errorCallBack);
    }

    const fetchAggregators = (filters=[], page_size = 10, page = 1, stortColumns = false, callBack, errorCallBack) => {
        serviceAgentEntities.fetchAggregators(filters, page_size, page, stortColumns, callBack, errorCallBack);
    }

    const fetchCommunityManagers = (filters=[], page_size = 10, page = 1, stortColumns = false, callBack, errorCallBack) => {
        serviceAgentEntities.fetchCommunityManagers(filters, page_size, page, stortColumns, callBack, errorCallBack);
    }

    const save = (values, callback, errorCallback) => {
        serviceEntities.save(values, callback, errorCallback);
    };

    const returnObj = {
        save, 
        fetchAll,
        fetchAggregators,
        fetchCommunityManagers
    }

    return (
        <ClientsContext.Provider value={returnObj}>
            {props.children}
        </ClientsContext.Provider>
    )
}

export const useClientsContext = () => {
    const context = useContext(ClientsContext);
    if (context === undefined) {
        throw new Error("useClientsContext must be used within a ClientsContextProvider");
    }
    return context;
}